import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NewUserData } from '@src/store/ducks/auth/types'

export const initialState = {
  isAuth: false,
  isLoading: false,
  backError: null as null | object | string,
  registerSuccess: false,
  changePasswordSuccess: false,
  isRecallPasswordNoUser: false,
  isSuccessRecallPassword: false,
  isSuccessRecoveryPassword: false,
  newUserData: {
    login: '',
    password: '',
  },
}
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsAuth(state, { payload }: PayloadAction<boolean>) {
      state.isAuth = payload
    },
    setIsLoading(state, { payload }: PayloadAction<boolean>) {
      state.isLoading = payload
    },
    setBackError(state, { payload }: PayloadAction<object | null | string>) {
      state.backError = payload
    },
    setRegisterSuccess(state) {
      state.registerSuccess = true
    },
    setChangePasswordSuccess(state, { payload }: PayloadAction<boolean>) {
      state.changePasswordSuccess = payload
    },
    setIsRecallPasswordNoUser(state, { payload }: PayloadAction<boolean>) {
      state.isRecallPasswordNoUser = payload
    },
    setIsSuccessRecallPassword(state, { payload }: PayloadAction<boolean>) {
      state.isSuccessRecallPassword = payload
    },
    setIsSuccessRecoveryPassword(state, { payload }: PayloadAction<boolean>) {
      state.isSuccessRecoveryPassword = payload
    },
    setNewUserData(state, { payload }: PayloadAction<NewUserData>) {
      state.newUserData = payload
    },
    resetState(state) {
      state.isLoading = false
      state.backError = null
      state.registerSuccess = false
      state.changePasswordSuccess = false
    },
    logoutAC() {},
  },
})
export type AuthStateType = typeof initialState
export const {
  setIsAuth,
  setIsLoading,
  setBackError,
  resetState,
  setRegisterSuccess,
  setChangePasswordSuccess,
  setIsRecallPasswordNoUser,
  setIsSuccessRecallPassword,
  setIsSuccessRecoveryPassword,
  setNewUserData,
  logoutAC,
} = authSlice.actions
export const authReducer = authSlice.reducer
